// HTMX Configuration - Compatible with Turbo Drive
function initializeHTMX() {
  // Remove existing event listeners to prevent duplicates
  const existingListeners = document.body.querySelectorAll('[data-htmx-initialized]');
  existingListeners.forEach(el => el.removeAttribute('data-htmx-initialized'));
  
  // Global function to show modal with loading state
  window.showModalWithLoading = function(jobTitle = '') {
    const modalElement = document.getElementById('global-modal');
    if (!modalElement) {
      return;
    }
    
    // Set loading content
    const modalBody = modalElement.querySelector('.modal-body');
    const modalTitle = modalElement.querySelector('.modal-title');
    
    if (modalBody) {
      modalBody.innerHTML = `
        <div class="text-center p-4">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">ロード中...</span>
          </div>
          <p class="text-muted mb-0">求人詳細を読み込み中...</p>
        </div>
      `;
    }
    
    if (modalTitle) {
      // Set job title if provided, otherwise show loading text
      modalTitle.textContent = jobTitle || '読み込み中...';
    }
    
    // Show modal immediately
    try {
      if (typeof bootstrap !== 'undefined') {
        // Dispose existing modal instance if any
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.dispose();
        }
        
        const modal = new bootstrap.Modal(modalElement, {
          backdrop: true,
          keyboard: true
        });
        modal.show();
      } else {
        // Fallback: manually show modal
        modalElement.classList.add('show');
        modalElement.style.display = 'block';
        modalElement.style.zIndex = '1055';
        document.body.classList.add('modal-open');
        
        // Remove existing backdrop if any
        const existingBackdrop = document.getElementById('modal-backdrop');
        if (existingBackdrop) {
          existingBackdrop.remove();
        }
        
        // Add backdrop
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'modal-backdrop';
        backdrop.style.zIndex = '1050';
        document.body.appendChild(backdrop);
      }
    } catch (error) {
      // Error showing modal
    }
  };
  
  // Add CSRF token to all HTMX requests and disable Turbo
  document.body.addEventListener('htmx:configRequest', function(event) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    if (event.detail && event.detail.headers) {
      event.detail.headers['X-CSRF-Token'] = csrfToken;
      // Disable Turbo for HTMX requests to prevent conflicts
      event.detail.headers['Turbo-Frame'] = 'false';
    }
  });

  // Log HTMX events for debugging
  document.body.addEventListener('htmx:beforeRequest', function(event) {
    // For modal requests, we don't reset the modal here since showModalWithLoading() handles it
    // This prevents the modal from flickering during the request
  });

  document.body.addEventListener('htmx:responseError', function(event) {
    // If it's a modal request that failed, show error message
    if (event.detail.pathInfo.requestPath.includes('/modal')) {
      const modalElement = document.getElementById('global-modal');
      if (modalElement) {
        const modalBody = modalElement.querySelector('.modal-body');
        const modalTitle = modalElement.querySelector('.modal-title');
        
        if (modalBody) {
          modalBody.innerHTML = `
            <div class="text-center p-4">
              <i class="bi bi-exclamation-triangle text-warning mb-3" style="font-size: 3rem;"></i>
              <h5 class="text-danger mb-3">エラーが発生しました</h5>
              <p class="text-muted mb-3">求人詳細の読み込みに失敗しました。</p>
              <button type="button" class="btn btn-outline-primary" onclick="location.reload()">
                <i class="bi bi-arrow-clockwise me-1"></i>再読み込み
              </button>
            </div>
          `;
        }
        
        if (modalTitle) {
          modalTitle.textContent = 'エラー - 求人詳細の読み込みに失敗';
        }
      }
    }
  });

  // Handle modal content loading
  document.body.addEventListener('htmx:afterSwap', function(event) {
    // If the swapped content is modal content, update the modal title
    if (event.target.id === 'global-modal' || event.target.closest('#global-modal')) {
      const modalElement = document.getElementById('global-modal');
      
      if (!modalElement) {
        return;
      }
      
      // Update modal title if it exists in the loaded content
      const modalTitle = modalElement.querySelector('.modal-title');
      
      // Try to find the job title in the loaded content
      let loadedTitle = null;
      
      // Look for job title in various possible locations
      const titleSelectors = [
        'h1.job-title',
        'h2.job-title', 
        'h3.job-title',
        'h1',
        'h2',
        'h3',
        '.job-title',
        '[data-job-title]'
      ];
      
      for (const selector of titleSelectors) {
        const element = event.target.querySelector(selector);
        if (element && element.textContent.trim()) {
          loadedTitle = element;
          break;
        }
      }
      
      if (modalTitle && loadedTitle) {
        modalTitle.textContent = loadedTitle.textContent.trim();
      } else if (modalTitle) {
        // Keep the current title if no new title is found
        // This preserves the job title that was set during loading
      }
      
      // Modal should already be visible from showModalWithLoading()
      // Just ensure it's properly initialized
      try {
        if (typeof bootstrap !== 'undefined') {
          const existingModal = bootstrap.Modal.getInstance(modalElement);
          if (!existingModal && modalElement.classList.contains('show')) {
            // Create new instance if modal is shown but no instance exists
            const modal = new bootstrap.Modal(modalElement, {
              backdrop: true,
              keyboard: true
            });
            // Don't call show() again since it's already visible
          }
        }
      } catch (error) {
        // Error updating modal
      }
    }
  });

  // Handle modal close events
  document.body.addEventListener('click', function(event) {
    const modalElement = document.getElementById('global-modal');
    
    // Close modal when clicking close button
    if (event.target.classList.contains('btn-close') || 
        event.target.getAttribute('data-bs-dismiss') === 'modal') {
      if (modalElement && modalElement.classList.contains('show')) {
        closeModal(modalElement);
      }
    }
    
    // Close modal when clicking backdrop
    if (event.target.classList.contains('modal-backdrop')) {
      if (modalElement && modalElement.classList.contains('show')) {
        closeModal(modalElement);
      }
    }
    
    // Close modal when clicking outside modal content
    if (modalElement && modalElement.classList.contains('show')) {
      const modalDialog = modalElement.querySelector('.modal-dialog');
      if (modalDialog && !modalDialog.contains(event.target)) {
        // Check if click is on the modal element itself (outside dialog)
        if (event.target === modalElement) {
          closeModal(modalElement);
        }
      }
    }
  });
  
  // Handle ESC key to close modal
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const modalElement = document.getElementById('global-modal');
      if (modalElement && modalElement.classList.contains('show')) {
        closeModal(modalElement);
      }
    }
  });
  
  // Function to close modal
  function closeModal(modalElement) {
    if (typeof bootstrap !== 'undefined') {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      } else {
        // Create new modal instance and hide it
        const modal = new bootstrap.Modal(modalElement);
        modal.hide();
      }
    } else {
      // Manual close
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');
      const backdrop = document.getElementById('modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }
  }

  document.body.addEventListener('flash', function(event) {
    const detail = event.detail || {};
    const type = detail.type || 'notice';
    const message = detail.message != null ? String(detail.message) : '';
    const htmlSafe = detail.html_safe || false;
    if (!message) return;
    showGlobalFlash(message, type, htmlSafe);
  });

  function showGlobalFlash(message, type, htmlSafe) {
    let container = document.getElementById('global-flash-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'global-flash-container';
      container.style.position = 'relative';
      container.style.zIndex = '10010';
      document.body.prepend(container);
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'position-fixed top-0 end-0 p-3';
    wrapper.style.zIndex = '10020';

    const toast = document.createElement('div');
    const colorClass = type === 'notice' || type === 'success' ? 'bg-success' : type === 'info' ? 'bg-info' : 'bg-danger';
    toast.className = `toast show align-items-center text-white ${colorClass} border-0`;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.setAttribute('aria-atomic', 'true');
    toast.dataset.bsDelay = '5000';

    const toastBodyWrapper = document.createElement('div');
    toastBodyWrapper.className = 'd-flex';

    const body = document.createElement('div');
    body.className = 'toast-body';
    body.innerHTML = htmlSafe ? message : escapeHtml(message);

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'btn-close btn-close-white me-2 m-auto';
    closeButton.setAttribute('data-bs-dismiss', 'toast');
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.addEventListener('click', function() {
      removeFlash(wrapper);
    });

    toastBodyWrapper.appendChild(body);
    toastBodyWrapper.appendChild(closeButton);
    toast.appendChild(toastBodyWrapper);
    wrapper.appendChild(toast);
    container.appendChild(wrapper);

    setTimeout(function() {
      removeFlash(wrapper);
    }, message.includes('<a') ? 6000 : 4000);
  }

  // グローバルに公開してReactコンポーネントからも利用可能にする
  window.showGlobalFlash = showGlobalFlash;

  function removeFlash(wrapper) {
    if (!wrapper) return;
    const toast = wrapper.querySelector('.toast');
    if (toast) {
      toast.classList.remove('show');
      setTimeout(function() {
        if (wrapper.parentNode) {
          wrapper.parentNode.removeChild(wrapper);
        }
      }, 150);
    } else if (wrapper.parentNode) {
      wrapper.parentNode.removeChild(wrapper);
    }
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function(char) {
      switch (char) {
        case '&': return '&amp;';
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '"': return '&quot;';
        case "'": return '&#39;';
        default: return char;
      }
    });
  }
}

// Initialize HTMX on DOM ready and Turbo events
document.addEventListener('DOMContentLoaded', initializeHTMX);
document.addEventListener('turbo:load', initializeHTMX);
document.addEventListener('turbo:render', initializeHTMX);

